import React from 'react';
import PricingCTA from './PricingCTA';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-black text-white pt-32">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-light tracking-wider mb-12">
            Privacy & Security
          </h1>

          <div className="space-y-12">
            {/* On-Premises Security */}
            <section className="bg-white/5 rounded-lg p-8 border border-white/10">
              <h2 className="text-2xl font-light mb-6">On-Premises Data Storage</h2>
              <p className="text-white/80 font-light leading-relaxed mb-6">
                All data captured by our camera network is stored locally on secure, on-premises infrastructure. This ensures maximum security and complete control over your sensitive information.
              </p>
              <div className="grid md:grid-cols-2 gap-6 mt-8">
                <div className="flex items-start">
                  <svg className="w-5 h-5 text-blue-400 mt-1 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-white/80">Physical security measures</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-5 h-5 text-blue-400 mt-1 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-white/80">Encrypted data storage</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-5 h-5 text-blue-400 mt-1 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-white/80">Access control systems</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-5 h-5 text-blue-400 mt-1 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-white/80">24/7 monitoring</span>
                </div>
              </div>
            </section>

            {/* Data Access */}
            <section className="bg-white/5 rounded-lg p-8 border border-white/10">
              <h2 className="text-2xl font-light mb-6">Controlled Data Access</h2>
              <p className="text-white/80 font-light leading-relaxed">
                We implement strict access controls and authentication protocols to ensure data is only accessible to authorized personnel and systems.
              </p>
            </section>

            {/* Compliance */}
            <section className="bg-white/5 rounded-lg p-8 border border-white/10">
              <h2 className="text-2xl font-light mb-6">Regulatory Compliance</h2>
              <p className="text-white/80 font-light leading-relaxed">
                Our infrastructure and practices are designed to meet or exceed relevant security standards and regulations for video surveillance systems.
              </p>
            </section>
          </div>

          {/* Contact Section */}
          <div className="mt-16 text-center">
            <h2 className="text-2xl font-light mb-8">
              Want to learn more about our security measures?
            </h2>
            <PricingCTA />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy; 